export default function parseNumber(value: string | number, { locale = '' } = {}) {
  if (typeof value === 'undefined' || value === null || value === '') {
    return NaN;
  }

  if (typeof value === 'number') {
    return value;
  }

  const stringValue = String(value);
  const cleanedValue = stringValue.replace(/[^\d ,.-]+/g, '').trim();
  const isFrenchFormat = cleanedValue.match(/^[0-9 ]+,[0-9]+$/);

  if (cleanedValue === '') {
    return NaN;
  }

  const shouldParseFrFormat = Boolean(
    isFrenchFormat &&
    (
      locale.startsWith('fr') ||
      cleanedValue.includes(' ')
    ),
  );

  if (shouldParseFrFormat) {
    return parseFrNumber(cleanedValue);
  }

  return parseEnNumber(cleanedValue);
}

function parseEnNumber(cleanedValue: string) {
  const convertedValue = cleanedValue
    .replace(/[\s]/g, '')
    .replace(/^0?,/g, '.')
    .replace(/[,]/g, '');
  return Number(convertedValue);
}

function parseFrNumber(cleanedValue: string) {
  const convertedValue = cleanedValue
    .replace(/[\s]/g, '')
    .replace(/[,]/g, '.');

  return Number(convertedValue);
}
